import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import HomePage from './pages/HomePage';
import QRDetailPage from './pages/QRDetailPage';
import './App.css';

/**
 * App - Main application component with routing
 * Routes:
 * - / : Main try-on flow (5 steps)
 * - /qr/:sessionId : QR code destination page
 */
function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/qr/:sessionId" element={<QRDetailPage />} />
      </Routes>
    </Router>
  );
}

export default App;
